import React from 'react';
import {Template} from "../../../../components/template/template.jsx";
import SosHomeActions from "./components/sos-home-actions.jsx";
import SosHomeProtected from "./components/sos-home-protected.jsx";
import SosHomeHistory from "./components/sos-home-history.jsx";
import {useQuery} from "@tanstack/react-query";
import sosService from "../../../../services/web/sos-service.js";
import useHasPermission from "../../../../hooks/use-has-permission.js";
import {PermissionEnum} from "../../../../utils/enums/permission-enum.js";

const SosHome = () => {
    const hasPermission = useHasPermission();

    const {data, isLoading} = useQuery({
        queryFn: () => sosService.home(),
        queryKey: ["sos-home"]
    });

    const hasCitizenPermission = hasPermission(PermissionEnum.SOS_MANAGE_CITIZEN) || hasPermission(PermissionEnum.SOS_VIEW);
    const hasEventPermission = hasPermission(PermissionEnum.SOS_MANAGE_EVENTS);

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>SOS Cidadão</Template.Title>
            </Template.Header>

            <Template.Body className={"h-[calc(100vh-53px)] overflow-y-auto grid grid-cols-4 grid-rows-[minmax(400px,1fr)_minmax(400px,1fr)] relative gap-4 p-4!"}>
                <SosHomeActions />

                {
                    hasCitizenPermission &&
                    <SosHomeProtected data={data} hasEventPermission={hasEventPermission}/>
                }

                {
                    hasEventPermission &&
                    <SosHomeHistory data={data} hasCitizenPermission={hasCitizenPermission}/>
                }
            </Template.Body>
        </Template>
    );
};

export default SosHome;